(function () {
  angular.module('lif.controllers').controller('aboutController', aboutController);
  aboutController.$inject = ['$scope', 'aboutGroupBootstrap'];

  function aboutController($scope, aboutGroupBootstrap) {
    var vm = this;
    vm.description = aboutGroupBootstrap.description;
    vm.showAllContent = false;

    vm.toggleContent = function () {
      vm.showAllContent = !vm.showAllContent;
    };
  }
})();